import cookies from 'js-cookie';
import { CreateElement, VNode } from 'vue';
import { Component, Vue } from 'vue-property-decorator';
import { FunctionalComponent } from '../decorators';

@Component
@FunctionalComponent
export default class AdminBar extends Vue {
    protected render(createElement: CreateElement): VNode {
        if (!cookies.get('SHOW_ADMIN_BAR')) {
            return createElement();
        }

        const editUrl = window.africaOptions.page.editUrl;
        const status = window.africaOptions.page.status;
        if (!editUrl || !status) {
            return createElement();
        }
        // Currently we able to show only published and draft posts.
        const POST_STATUS_PUBLISH = 'publish';

        const nodes = [
            createElement('a', {
                attrs: {
                    href: '/cms/wp-admin',
                },
                style: {
                    marginRight: '6px',
                },
            }, [
                createElement('i', { staticClass: 'u-fa u-fa-dashboard', staticStyle: { marginRight: '6px' }}),
                'Dashboard',
            ]),
        ];

        if (editUrl) {
            let label = 'Edit Page';
            if (status && status !== POST_STATUS_PUBLISH) {
                label += ' (draft)';
            }
            nodes.push(createElement('a', {
                attrs: {
                    href: editUrl,
                },
            }, [
                createElement('i', { staticClass: 'u-fa u-fa-pencil', staticStyle: { marginRight: '6px' }}),
                label,
            ]));
        }

        document.body.classList.add('has-admin-bar');

        return createElement('div', {
            staticClass: 'c-admin-bar',
        }, nodes);
    }
}



// WEBPACK FOOTER //
// ./src/components/AdminBar.ts